<template>
  <div>
    <div class="box">
      <div class="box2">
        <div class="centered-content">
          <img src="../../assets/images/icon_success@2x.png" alt="" width="48px" height="48px">
          <span class="box2-font">账号注册成功</span>
        </div>

      </div>
      <div class="box3">
        <div style="margin-left: -15px;">
          <img :src="image" alt="" width="150px"  >
        </div>
        <div>
          <button type="button" class="button" @click="xiazai">下载安卓版</button>
        </div>
      </div>
    </div>
      <!-- <img src="../../assets/images/tip-info@2x.png" width="375px" height="572px"> -->
  </div>
</template>

<script>
import axios from 'axios'; // 导入 axios 库
  export default {
    name:'',
    props:[''],
    data () {
      return {
        image:undefined
      };
    },
    created(){
      console.log('111111111111')
      axios.get('https://api.zhibo.yunji.world/web/download').then(res => {
                console.log(res);
                this.image=res.data.result.logo;
              window.open(res.data.result.url, '_blank');

            }).catch(error => {
                console.log(error);
            })
    },
    components: {},

    computed: {},

    beforeMount() {},

    mounted() {},

    methods: {
      xiazai(){
        axios.get('https://api.zhibo.yunji.world/web/download').then(res => {
              window.open(res.data.result.url, '_blank');

            }).catch(error => {
                console.log(error);
            })

      }
    },

    watch: {}

  }

</script>
<style lang='less' scoped>
    @import 'vant/lib/index.css';
    @import '../../assets/style/dowmload.less';
</style>